import season from "@/api/seasons";

export default {
  state: {
    seasons: []
  },
  mutations: {
    ["RETRIEVE_SEASONS"](state, data) {
      state.seasons = data;
    }
  },
  actions: {
    async retrieveSeasons(context) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID"),
          include_outof_paddy_field_item: true
        };
        let res = await season.index(params);
        context.commit("RETRIEVE_SEASONS", res.data.data);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async insertSeasons(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        await season.insert(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateSeasons(context, params) {
      try {
        params.account_id = await context.dispatch("showAccountID");
        await season.update(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrderSeasons(context, params) {
      try {
        await season.updateOrder(params);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteSeasons(context, id) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          season_id: id
        };
        await season.del(params);
      } catch (error) {
        console.log(error);
      }
    },
    async initializeSeasons(context) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID")
        };
        await season.init(params);
      } catch (error) {
        console.log(error);
      }
    }
  },
  getters: {
    getSeasons(state) {
      return state.seasons;
    }
  }
};
